import {ConfigProvider, theme} from "antd";
import locRu from 'antd/locale/ru_RU';
import './App.css';
import {AppLayout} from "./components/AppLayout/AppLayout";
import { Provider } from 'react-redux';
import { setupStore } from './store';

function App() {
     const store = setupStore();
     
  return (
   
    <Provider store={store}>
        <ConfigProvider locale={locRu} theme={{
                // 1. Use dark algorithm
                algorithm: theme.defaultAlgorithm,
                token: {
                    // Seed Token
                    borderRadius: 8,
                    colorPrimary: "#61AF3D",
                    fontFamily:"Montserrat"
                },

            }}>
                    <AppLayout/>
            </ConfigProvider>
    </Provider>
  );
}

export default App;
